// src/utils/auth-helper.js
import AccountsSDK from '@livechat/accounts-sdk';
import {
  setAccessTokenStore,
  setAccessRegionStore,
  getAccessTokenStore,
  getAccessRegionStore
} from './store';

const accountsSDK = new AccountsSDK({
  client_id: process.env.REACT_APP_CLIENT_ID,
});

export const refreshAccessToken = async () => {
  try {
    const data = await accountsSDK.popup().authorize(); 

    const token = data.access_token;

    const parts = token.split(":");
    const region = parts.length === 2 ? parts[0] : "dal";


    setAccessTokenStore(token);
    setAccessRegionStore(region);

    return token;
  } catch (error) {
    console.error("Failed to refresh access token", error);
    return null;
  }
};
